import { render } from "./ApprovalActionPanel.vue?vue&type=template&id=438cd0bb&scoped=true"
import script from "./ApprovalActionPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalActionPanel.vue?vue&type=script&lang=js"

import "./ApprovalActionPanel.vue?vue&type=style&index=0&id=438cd0bb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438cd0bb"],['__file',"src/views/h5/common/approval/ApprovalActionPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "438cd0bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('438cd0bb', __exports__)) {
    api.reload('438cd0bb', __exports__)
  }
  
  module.hot.accept("./ApprovalActionPanel.vue?vue&type=template&id=438cd0bb&scoped=true", () => {
    api.rerender('438cd0bb', render)
  })

}


export default __exports__